export default __webpack_public_path__ + "static/media/hdfc.006f5514.jpg";